import React from 'react';

import PulseMonitor from './PulseMonitor.js';
import { RESPIRATORY_RATE, respirationAmplitude } from './pulseModel.js';

const COLOR = [255, 232, 75];
const sample = (seconds) => 125 - 75 * respirationAmplitude(seconds);
const readout = () => RESPIRATORY_RATE;

const RespSketch = () => (
  <PulseMonitor
    label="RESP"
    className="resp"
    color={COLOR}
    sample={sample}
    readout={readout}
    limits={[8, 30]}
    initialValue={RESPIRATORY_RATE}
    valueId="resp-rate-value"
    unit="RR /min"
  />
);

export default RespSketch;
